export default __webpack_public_path__ + "static/media/logo-wide.a7c15424.svg";